import { createContext, useContext } from "react";

export const CaptureContext = createContext({ openCapture: () => {} });
export const useCapture = () => useContext(CaptureContext);
